import type { PipeTransform } from '@angular/core';
import { Pipe } from '@angular/core';
import { round } from '@shared/utils/math';

@Pipe({ name: 'round' })
export class AppRoundPipe implements PipeTransform {
    transform(value: number, precision: number = 0): number {
        return round(value, precision);
    }
}
